import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../../api";

import { Row, Col, Label, Input, InputGroup, FormFeedback } from 'reactstrap';
import ParadigmaAsyncSeeker from "../../../components/ParadigmaAsyncSeeker/ParadigmaAsyncSeeker.js"


class Delete extends Component {
    constructor(props) {
        super(props);
        this.state = {
            departamento: null,
        };
    }

    static propTypes = {
        onSubmit: PropTypes.func.isRequired,
        id: PropTypes.func.isRequired,
    }

    ResetForm() {
        this.setState({
            departamento: null,
        });
    }

    setSelects(data) {
        this.setState({
            departamento: data.departamento_id,
        });
    }
    render() {
        return (
            <ParadigmaModal
                getUrl={api.usuarios.personal.delete}
                postUrl={api.usuarios.personal.delete}
                onSubmit={() => this.props.onSubmit()}
                id={this.props.id}
                successMessage={"La Persona ha sido eliminada con éxito."}
                notAllowedMessage={"La Persona no puede ser eliminada ya que se encuentra siendo utilizada por el sistema."}
                missingIdMessage={"Debe seleccionar una fila."}
                title={"Eliminar Persona"}
                buttonIcon={"fa fa-trash fa-lg"}
                
                saveButton={true}
                closeButton={true}
                buttonClass={"btn-danger"}
                danger={true}
                saveButtonLabel={"Eliminar"}
                onGotData={(data) => this.setSelects(data)}
                onClose={() => this.ResetForm()}
            >
                <Row>
                    <Col className="col-6">
                        <Label>Apellido</Label>
                        <Input disabled={true} type="text" name="apellido"></Input>
                        <FormFeedback className="col-12"></FormFeedback>
                    </Col>
                    <Col className="col-6">
                        <Label>Nombre</Label>
                        <Input disabled={true} type="text" name="nombre"></Input>
                        <FormFeedback className="col-12"></FormFeedback>
                    </Col>
                </Row>
                <Row>
                    <Col className="col-6">
                        <Label>DNI</Label>
                        <Input disabled={true} type="text" name="dni"></Input>
                        <FormFeedback className="col-12"></FormFeedback>
                    </Col>
                    <Col className="col-6">
                        <Label>Domicilio</Label>
                        <Input disabled={true} type="text" name="domicilio"></Input>
                        <FormFeedback className="col-12"></FormFeedback>
                    </Col>
                </Row>
                <Row>
                    <Col className="col-8">
                        <Label>Email</Label>
                        <Input disabled={true} type="text" name="email"></Input>
                        <FormFeedback className="col-12"></FormFeedback>
                    </Col>
                    <Col className="col-4">
                        <Label>Teléfono</Label>
                        <Input disabled={true} type="text" name="telefono"></Input>
                        <FormFeedback className="col-12"></FormFeedback>
                    </Col>
                </Row>


                <Row>
                    <Col className="col-12">
                        <Label>Grupos</Label>
                        <ParadigmaAsyncSeeker fieldName={""}
                            url={api.usuarios.grupos.select}
                            value={this.state.departamentopadre_id} />
                        <FormFeedback className="col-12"></FormFeedback>
                    </Col>
                </Row>

                <Row>
                    <Col className="col-12">
                        <Label>Subgrupos</Label>
                        <ParadigmaAsyncSeeker fieldName={"departamento_id"}
                            url={api.usuarios.subgrupos.select + (this.state.departamentopadre_id ? "?grupo=" + this.state.departamentopadre_id : "")}
                            value={this.state.departamento} />
                        <FormFeedback className="col-12"></FormFeedback>
                    </Col>
                </Row>
            </ParadigmaModal>
        );
    }
}

export default Delete;



// WEBPACK FOOTER //
// ./src/views/Usuarios/Personal/Delete.js